import { render } from "./TestimonialRotator.vue?vue&type=template&id=55eb7db2&scoped=true"
import script from "./TestimonialRotator.vue?vue&type=script&lang=js"
export * from "./TestimonialRotator.vue?vue&type=script&lang=js"

import "./TestimonialRotator.vue?vue&type=style&index=0&id=55eb7db2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55eb7db2"]])

export default __exports__